import { onMounted, ref }   from "vue";
import { useRoute }         from "vue-router";
import { useFetch }         from "../utils.js";
import { useLocale }        from "../locales/i18n.js";


//////////////////////////////////////////////////
//  REPORT
//////////////////////////////////////////////////


export default {

    setup() {
        const { i18n }      = useLocale();
        const { fetch }     = useFetch();
        const route         = useRoute();
        const refLoading    = ref(true);
        const refReport     = ref(null);

        onMounted(async () => {
            const userId    = route.query["userId"];
            const reason    = route.query["reason"];
            const createdAt = Number(route.query["createdAt"]);
            const signature = route.query["sig"];

            try {
                refLoading.value = true;

                const report = await fetch("/api/report", {
                    method  : "POST",
                    body    : JSON.stringify({
                        userId,
                        createdAt,
                        signature,
                    }),
                }).then((res) => res.json());

                console.log(report);

                refReport.value = report;

            } finally {
                refLoading.value = false;
            }
        });

        return () => {
            if (refLoading.value)
                return <div class="notice">{i18n("page.report.loading_text")}</div>;

            return (
                <div id="app">
                    ez
                </div>
            );
        };
    },
}
